import { HelpItem } from "./HelpItem"
import openIcon from "./selecticon.png"
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

export const Help = () => {
   // language translator
 const { t } = useTranslation("translation")
 const containerRef = useRef<HTMLDivElement>(null)
 const [isAtStart, setIsAtStart] = useState(true)
 const [isAtEnd, setIsAtEnd] = useState(false)
 const nestedArrayStructure = [
  {
   heading: "ReTCon VI",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
   ],
  },
  {
   heading: "Contact",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
   ],
  },
  {
   heading: "Operating System",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
   ],
  },
 ]
 useEffect(() => {
  if (containerRef.current) {
   containerRef.current.addEventListener("scroll", handleScroll)
   return () => {
    // eslint-disable-next-line
    containerRef.current?.removeEventListener("scroll", handleScroll)
   }
  }
  // eslint-disable-next-line
 }, [])
 //   horizontal scroll method for changing the color of active button
 const handleScroll = () => {
  if (containerRef.current) {
   setIsAtStart(containerRef.current.scrollLeft === 0)
   setIsAtEnd(
    containerRef.current.scrollLeft + containerRef.current.clientWidth ===
     containerRef.current.scrollWidth,
   )
  }
 }
 //   scrollLeft method
 const scrollLeft = () => {
  if (containerRef.current) {
   containerRef.current.scrollLeft -= 100
  }
 }
 //   scrollRight method
 const scrollRight = () => {
  if (containerRef.current) {
   containerRef.current.scrollLeft += 100
  }
 }

 return (
  <div className="w-[96%] mx-auto pt-6">
   <div className="flex justify-between w-full">
    <div>
     <h1 className="font-semibold text-2xl">{t("help")}</h1>
     <p className="text-xs pt-2 pb-4">
      Online Help : <span className="text-light-blue">Help (PDF)</span>
     </p>
    </div>

    <div className="flex w-[6%]  justify-between">
     <button
      onClick={scrollLeft}
      className={`h-6 w-6 rounded-lg flex items-center justify-center ${
       isAtStart ? "opacity-40 bg-white" : "bg-white"
      } `}
     >
      <img className="rotate-[-90deg]" src={openIcon} alt="prev" />
     </button>
     <button
      onClick={scrollRight}
      className={`h-6 w-6 rounded-lg flex items-center justify-center ${
       isAtEnd ? "opacity-40 bg-white" : "bg-white"
      }`}
     >
      <img className="rotate-90" src={openIcon} alt="next" />
     </button>
    </div>
   </div>

   <div
    ref={containerRef}
    className="flex lg:flex-row flex-col gap-3 overflow-x-scroll  hide-scroll-icon"
   >
    {nestedArrayStructure.map((item, index) => (
     <div key={index} className="min-w-[45%]">
      {/* =========== HelpItem component for removing duplicates ====== */}
      <HelpItem item={item} index={index} />
     </div>
    ))}
   </div>
  </div>
 )
}
